import {
  InputCssConfig,
  InputFieldSettings,
  WorkflowWidgetConfigurationAttributes,
} from '@finxone-platform/shared/sys-config-types';

export { TransactionHistoryTopRightOption } from '@finxone-platform/shared/enums';

export type popupName = {
  [key: string]: string;
};

export type ImagePopupSettingConfig = {
  show: boolean;
  type: string;
};

export function updateInputFieldWidgetPropertiesByKey(
  key: string,
  value: string | number | boolean,
  widgetAttributes: WorkflowWidgetConfigurationAttributes,
): InputFieldSettings {
  if (Object.keys(widgetAttributes.widgetProperties.inputFieldSettings?.css_config ?? {}).includes(key)) {
    return JSON.parse(
      JSON.stringify({
        ...widgetAttributes.widgetProperties.inputFieldSettings,
        css_config: {
          ...widgetAttributes.widgetProperties.inputFieldSettings?.css_config,
          [key]: value,
        } as InputCssConfig,
      } as InputFieldSettings),
    );
  } else {
    return JSON.parse(
      JSON.stringify({
        ...widgetAttributes.widgetProperties.inputFieldSettings,
        [key]: value,
      } as InputFieldSettings),
    );
  }
}
